export default __webpack_public_path__ + "static/arindamLehri10-d475e8eec9c3429dba207e66e7a92d82.jpg";